<template>
  <div style="height: 100%">
    <div v-if="loading" class="loadingContainer">
      <Loader isLoading />
    </div>
    <Transition name="fadeQuick">
      <div v-if="!loading" class="mainContainer">
        <header class="header">
          <span
            :style="{ 'color': isFinished ? '#ED0059' : '#64748B' }"
            class="activeSuperLimit"
          >
            {{ isFinished ? 'Super Limite ativado' : 'Ativar Super Limite' }}
          </span>
          <asset-v3 style="height: 28px" dir="icons" name="ame-parcelex-logo.svg" />
          <slot name="header" />
        </header>
        <main class="main" :style="{ height: autoHeight ? 'auto' : '100%' }">
          <slot />
        </main>
      </div>
    </Transition>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import AssetV3 from '@/components/common/AssetV3.vue';
import Loader from '@/feature/minified-onboarding/components/Loader.vue';

export default defineComponent({
  name: 'DefaultLayout',
  props: {
    autoHeight: Boolean,
    loading: Boolean,
  },
  components: {
    Loader,
    AssetV3,
  },
  setup() {
    const route = useRoute();
    const isFinished = computed(() => route.name === 'onboarding-minified-complete');

    return {
      isFinished,
    };
  },
});
</script>
<style lang="scss" scoped>
.loadingContainer {
  display: flex;
  overflow: auto;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

.mainContainer {
  display: flex;
  overflow: auto;
  padding: 1.5rem;
  min-height: 90%;
  height: 90%;
  height: -webkit-fill-available;
  position: absolute;
  inset: 0;
  border-top: 4px solid #ed0059;
  flex-direction: column;
  background-color: #ffffff;

  > .header {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: flex-start;

    > .activeSuperLimit {
      size: 14px;
      line-height: 20px;
      font-weight: 600;
    }
  }

  > .main {
    display: flex;
    flex-direction: column;
  }
}
</style>
